import { render, staticRenderFns } from "./plain_card.vue?vue&type=template&id=7262aa82&scoped=true&"
import script from "./plain_card.vue?vue&type=script&lang=js&"
export * from "./plain_card.vue?vue&type=script&lang=js&"
import style0 from "./plain_card.vue?vue&type=style&index=0&id=7262aa82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7262aa82",
  null
  
)

export default component.exports